import { render, staticRenderFns } from "./Facture.vue?vue&type=template&id=22309543&scoped=true"
import script from "./Facture.vue?vue&type=script&lang=js"
export * from "./Facture.vue?vue&type=script&lang=js"
import style0 from "./Facture.vue?vue&type=style&index=0&id=22309543&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22309543",
  null
  
)

export default component.exports